module.exports = __webpack_public_path__ + "img/54_28.4cc40375.png";